<script setup>
import { computed } from 'vue';
import { Handle, Position } from '@vue-flow/core';
import { NODE_TYPES, CONDITION_OPERATORS } from '../../constants';
import FlowNodeCard from './FlowNodeCard.vue';

const props = defineProps({
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});
const meta = NODE_TYPES.condition;
const operatorLabel = computed(
  () => CONDITION_OPERATORS.find(o => o.value === props.data.operator)?.label || props.data.operator
);
</script>

<template>
  <FlowNodeCard :icon="meta.icon" :color="meta.color" :title="meta.label" :selected="selected">
    <Handle type="target" :position="Position.Left" />
    <p>
      <span class="font-medium text-n-slate-12">{{ data.variable || '(variável)' }}</span>
      {{ operatorLabel }}
      <span v-if="data.value" class="font-medium text-n-slate-12">"{{ data.value }}"</span>
    </p>
    <div class="flex items-center justify-between mt-2 text-[11px]">
      <span class="text-n-teal-11">✓ verdadeiro</span>
      <span class="text-n-ruby-11">✗ falso</span>
    </div>
    <Handle id="true" type="source" :position="Position.Right" style="top: 62%" />
    <Handle id="false" type="source" :position="Position.Bottom" />
  </FlowNodeCard>
</template>
